import { api } from '../index';

export const getAll = () => api.get('/knowledge-base');
